<div class="tw-flex tw-flex-col tw-gap-2">
  @if(feedbackItem) {
  <div class="tw-flex tw-flex-col tw-gap-2 tw-py-3 tw-rounded-md tw-bg-white">
    <div class="tw-flex tw-gap-2 tw-rounded-md tw-bg-white">
      @for (i of [1,2,3,4,5]; track $index) {
      <i class="pi pi-star-fill tw-text-lg" [ngClass]="{
        'tw-cursor-pointer': !readOnly,
        'tw-text-gray-500': !(feedbackItem.Rating >= i), 
        'tw-text-yellow-500': feedbackItem.Rating >= i }" (click)="feedbackItem.Rating=i"></i>
      }
    </div>
    @if(feedbackItem.Rating > 0) {
    <div class="tw-text-sm">Details</div>
    @if(readOnly) {
    <blockquote class="tw-whitespace-pre">{{feedbackItem.Comment}}</blockquote>
    } @else {
    <textarea pInputTextarea [(ngModel)]="feedbackItem.Comment" placeholder="Share your feedback" [rows]="3"></textarea>
    }

    @if(canReply) {
    <textarea pInputTextarea [(ngModel)]="feedbackItem.Reply" placeholder="Your reply here" [rows]="3"></textarea>
    } @else {
    @if(feedbackItem.Reply) {
    <blockquote class="tw-whitespace-pre tw-italic tw-p-2 tw-ms-8 tw-bg-slate-100 tw-rounded-md">{{feedbackItem.Reply}}
    </blockquote>
    }
    }

    }
  </div>
  }
</div>